import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import "./../assets/sass/totalreview.css";
import axios from "axios";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { validateHeader, API_Link } from "../commons/Constants";
import { MdContentCopy, MdCheck, MdCancel } from "react-icons/md";
import { FiFilter } from "react-icons/fi";
import ConfirmAddArticlesModal from "./confirmAddArticlesModal";
import FilterModal from "./FilterModal";
import { useSnackbar } from "notistack";
import { BsSortAlphaDown } from "react-icons/bs";
import {
  Loader,
  Loader2,
  LoaderSmall,
} from "./webWorkers/LoaderFile/Loader.js";
import parse from "html-react-parser";

// Web Worker Setup
// const worker = new Worker(
//   new URL("./webWorkers/selectionWorker", import.meta.url)
// );

const ListingSelectionsComponentNew = () => {
  const navigate = useNavigate();
  const MD5hash = validateHeader();
  const { enqueueSnackbar } = useSnackbar();

  //local storage
  const { token } = JSON.parse(localStorage.getItem("user")) || {};
  const studyId = JSON.parse(localStorage.getItem("studyId")) || "";
  const picoData = JSON.parse(localStorage.getItem("picoData") || "null") || "";
  const records = JSON.parse(localStorage.getItem("search") || "null");
  const info = JSON.parse(localStorage.getItem("info") || "null") || "";

  //states
  const [query, setQuery] = useState("");
  const [count, setCount] = useState("");

  const [showRemoveArticlesModal, setShowRemoveArticlesModal] = useState(false);
  const [isSubmitingArticles, setIsSubmitingArticles] = useState(false);
  const [permissions, setPermission] = useState([]);
  const [articles, setArticles] = useState([]);
  const [articlesAbstracts, setArticlesAbstracts] = useState([]);
  const [activeAbstract, setActiveAbstract] = useState(null);
  const [payloadArticles, setPayloadArticles] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [emptyTitleOrAbstractCount, setEmptyTitleOrAbstractCount] =
    useState(null);
  const [copyText, setCopyText] = useState("Copy query");

  // sorting
  const [showSortingDropdown, setShowSortingDropdown] = useState(false);
  const sortingDropDownRef = useRef(null);
  const [beforSortingArticles, setBeforSortingArticles] = useState([]);
  const [beforSortingFilterArticles, setBeforSortingFilterArticles] = useState(
    []
  );
  const [isSortingApplied, setIsSortingApplied] = useState(false);

  // filter state
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isSelectAllLoader, setIsSelectAllLoader] = useState(false);
  const [isIncludingReview, setIsIncludingReview] = useState(false);
  const [isLoaderApply, setIsLoaderApply] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [selectedFilterTypes, setSelectedFilterTypes] = useState({
    year: [],
    author: [],
    journal: [],
  });
  const [filterOptions, setFilterOptions] = useState([]);
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [listingLoader, setListingLoader] = useState(false);

  //functions
  const parseAuthor = (authors) => {
    if (Array.isArray(authors)) {
      return authors.join(", ");
    } else if (typeof authors === "string") {
      return authors;
    }
    return authors;
  };

  const capitalizeWords = (text) => {
    if (!text || typeof text !== "string") return "";

    return text
      .toLowerCase()
      .split(" ")
      ?.map((word) =>
        word.charAt(0).match(/[a-zA-Z]/)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word
      )
      .join(" ");
  };

  const extractYear = (text) => {
    const year = text.slice(0, 4);
    return /^\d{4}$/.test(year) ? Number(year) : null;
  };

  const parseRisData = (data) => {
    const parseData = data?.map((item, index) => ({
      id: Number(item.ID),
      title: capitalizeWords(item.title),
      authors: item.authors + ".",
      journal: capitalizeWords(item.journal) + ".",
      doi: item.doi,
      year: extractYear(item.year),
    }));

    const abstracts = data?.map((item) => ({
      id: Number(item.ID),
      abstract: item.abstract,
    }));

    return { parseData, abstracts };
  };

  const parsePubmidData = (data) => {
    const parseData = data?.map((item, index) => ({
      id: Number(item.pubmed_id),
      title: capitalizeWords(item.Title),
      authors: parseAuthor(item.Authors),
      journal: capitalizeWords(item.Journal),
      year: extractYear(item["Date of Publication"]),
      pubmed_id: item.pubmed_id,
    }));

    const abstracts = data?.map((item) => ({
      id: Number(item.pubmed_id),
      abstract: item.abstract,
    }));

    return { parseData, abstracts };
  };

  const parseArticles = () => {
    setListingLoader(true);
    let parseData = [];
    let abstracts = [];

    if (picoData?.Database === "RISimport") {
      ({ parseData, abstracts } = parseRisData(records));
    } else if (picoData?.Database === "pubMeD") {
      ({ parseData, abstracts } = parsePubmidData(records));
    } else {
      return;
    }

    setArticles(parseData);
    setBeforSortingArticles(parseData);
    setArticlesAbstracts(abstracts);
    setTimeout(() => {
      setListingLoader(false);
    }, 1000);
  };

  const formatOvidTags = (text) => {
    if (!text) return "";

    return parse(
      text
        .replace(/<ovid:b>(.*?)<\/ovid:b>/g, "\n<b>$1</b>")
        .replace(/<ovid:i>(.*?)<\/ovid:i>/g, "<i>$1</i>")
        .replace(/<ovid:sub>(.*?)<\/ovid:sub>/g, "<sub>$1</sub>")
        .replace(/<ovid:sup>(.*?)<\/ovid:sup>/g, "<sup>$1</sup>")
        .replace(/<ovid:u>(.*?)<\/ovid:u>/g, "<u>$1</u>")
        .replace(/<ovid:br\/>/g, "<br>")
        .replace(
          /<ovid:link href="(.*?)">(.*?)<\/ovid:link>/g,
          "<a href='$1'>$2</a>"
        )
        .replace(/<ovid:hl>(.*?)<\/ovid:hl>/g, "<mark>$1</mark>")
        .replace(/<ovid:para>(.*?)<\/ovid:para>/g, "<p>$1</p>")
        .replace(/<ovid:strike>(.*?)<\/ovid:strike>/g, "<s>$1</s>")
    );
  };

  const parseInfo = () => {
    if (picoData?.Database === "pubMeD") {
      setCount(info[0].Count);
      setQuery(info[0].Query);
    } else {
      return;
    }
  };

  ////////----> Code for copy text for both HTTP and HTTPS <----\\\\\\\\

  const handleCopyText = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      // Use the modern clipboard API in secure contexts (HTTPS or localhost)
      navigator.clipboard.writeText(text).then(() => {
        setCopyText("Copied!");
        setTimeout(() => setCopyText("Copy query"), 2000);
      });
    } else {
      // Fallback for HTTP: create a temporary textarea and use execCommand
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setCopyText("Copied!");
        setTimeout(() => setCopyText("Copy query"), 2000);
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleNavigateBack = () => {
    navigate(
      picoData?.Database === "pubMeD" ? "/searchinginclusion" : "/risimport"
    );
  };

  const handleSelectAll = useCallback(() => {
    const sourceArticles = isFilterApplied ? filteredArticles : articles;
    if (sourceArticles?.length === 0) {
      return;
    }
    setSelectedIds((prevIds) => {
      const sourceIds = sourceArticles?.map((article) => article.id);

      if (filteredArticles.length) {
        // Case when filteredArticles is the source
        const allFilteredSelected = sourceIds.every((id) =>
          prevIds.includes(id)
        );

        if (allFilteredSelected) {
          // Deselect only the filtered articles
          return prevIds.filter((id) => !sourceIds.includes(id));
        } else {
          // Add filtered articles to the existing selection (avoid duplicates)
          const newSelection = new Set([...prevIds, ...sourceIds]);
          return Array.from(newSelection);
        }
      } else {
        // Case when all articles are the source (no filters applied)
        return prevIds.length === sourceIds.length ? [] : sourceIds;
      }
    });
  }, [articles, filteredArticles]);

  // const handleSelectAll = () => {
  //   worker.postMessage({
  //     action: "selectAll",
  //     prevIds: selectedIds,
  //     filteredArticles,
  //     articles,
  //   });
  // };

  // useEffect(() => {
  //   worker.onmessage = (event) => {
  //     setSelectedIds(event.data);
  //   };

  //   return () => {
  //     worker.terminate();
  //   };
  // }, []);

  const handleSelectChange = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== id)
        : [...prevSelectedIds, id]
    );
  };

  const getPermissions = async () => {
    const config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${studyId}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios(config);
      setPermission(response?.data?.permissions[0]);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const handleSubmitArticles = async (articlesPayload) => {
    setIsIncludingReview(true);
    setIsSubmitingArticles(true);

    const chunkSize = 500;
    const maxRetries = 1;
    const sendChunkWithRetries = async (chunk, attempt = 1) => {
      const config = {
        method: "post",
        url: `${API_Link}addArticles`,
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
        data: {
          review_id: studyId,
          database: picoData.Database,
          population: picoData.Population,
          intervention: picoData.Intervention,
          comparison: picoData.Comparison,
          outcome: picoData.Outcomes,
          exclusion: picoData.Exclusion,
          pubmid_query: query,
          total_records: articlesPayload.length,
          included: selectedIds.length,
          articles: chunk,
        },
      };

      try {
        const response = await axios(config);
        if (response?.data?.status !== 1) {
          throw new Error("Server returned an error for the chunk.");
        }
      } catch (error) {
        if (attempt < maxRetries) {
          console.warn(`Retrying chunk... Attempt ${attempt + 1}`);
          await sendChunkWithRetries(chunk, attempt + 1);
        } else {
          throw new Error("Max retries reached for the chunk.");
        }
      }
    };

    try {
      for (let i = 0; i < articlesPayload.length; i += chunkSize) {
        const chunk = articlesPayload.slice(i, i + chunkSize);
        await sendChunkWithRetries(chunk);
      }
      enqueueSnackbar("All articles included successfully!", {
        variant: "success",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });

      setIsIncludingReview(false);
      setIsSubmitingArticles(false);
      navigate("/searchabstracts");
    } catch (error) {
      enqueueSnackbar(
        "An error occurred while including articles. Please try again later.",
        {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        }
      );

      setIsSubmitingArticles(false);
      setIsIncludingReview(false);
    }
  };

  const selectedArticles = useMemo(() => {
    return articles
      ?.filter((article) => selectedIds.includes(article.id))
      ?.map((article) => {
        const { id, serial_no, ...articleWithoutId } = article;
        return {
          ...articleWithoutId,
          abstract:
            articlesAbstracts.find((abstract) => abstract.id === article.id)
              ?.abstract || "",
        };
      });
  }, [articles, selectedIds, articlesAbstracts]);

  const handleIncludeArticles = () => {
    const emptyTitleOrAbstractCount = selectedArticles?.filter(
      (article) =>
        article.abstract === "" ||
        article.title === "" ||
        article.title === "?" ||
        article.abstract === "?"
    );

    if (emptyTitleOrAbstractCount?.length > 0) {
      const parseSelectedArticles = selectedArticles?.filter(
        (article) =>
          article.abstract !== "" &&
          article.title !== "" &&
          article.title !== "?" &&
          article.abstract !== "?"
      );

      setEmptyTitleOrAbstractCount(emptyTitleOrAbstractCount?.length);
      setPayloadArticles(parseSelectedArticles);

      setShowRemoveArticlesModal(true);
    } else {
      handleSubmitArticles(selectedArticles);
    }
  };

  // ****************Filters Funtion***************
  const handleFilterChange = (type) => {
    setFilterType(type);

    // Step 1: Filter articles based on currently selected options
    const optimizedArticles = articles.filter((article) => {
      const matchYear = selectedFilterTypes.year.length
        ? selectedFilterTypes.year.includes(article.year)
        : true;

      const matchAuthor = selectedFilterTypes.author.length
        ? selectedFilterTypes.author.some((selectedAuthor) =>
            article.authors
              .split(",")
              ?.map((a) => a.trim())
              .includes(selectedAuthor)
          )
        : true;

      const matchJournal = selectedFilterTypes.journal.length
        ? selectedFilterTypes.journal.includes(article.journal)
        : true;

      return matchYear && matchAuthor && matchJournal;
    });

    // Step 2: Generate options for the current filter type based on filtered articles
    if (type === "year") {
      const years = Array.from(
        new Set(optimizedArticles?.map((article) => article.year))
      )
        .filter(Boolean)
        .sort((a, b) => b - a)
        ?.map((year) => ({
          type: "year",
          label: year.toString(),
          value: year,
        }));
      setFilterOptions(years);
    } else if (type === "author") {
      const authors = Array.from(
        new Set(
          optimizedArticles.flatMap((article) =>
            article.authors.split(",")?.map((author) => author.trim())
          )
        )
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b))
        ?.map((author) => ({ type: "author", label: author, value: author }));
      setFilterOptions(authors);
    } else if (type === "journal") {
      const journals = Array.from(
        new Set(optimizedArticles?.map((article) => article.journal))
      )
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b))
        ?.map((journal) => ({
          type: "journal",
          label: journal,
          value: journal,
        }));
      setFilterOptions(journals);
    }
  };

  const handleSelectFilterChange = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setSelectedFilterOptions([]);
      setSelectedFilterTypes({
        year: [],
        author: [],
        journal: [],
      });
      setFilterOptions([]);
      setFilterType("");
    } else {
      setSelectedFilterOptions(selectedOptions);

      const yearValues = selectedOptions
        .filter((option) => option.type === "year")
        ?.map((option) => option.value);
      const authorValues = selectedOptions
        .filter((option) => option.type === "author")
        ?.map((option) => option.value);
      const journalValues = selectedOptions
        .filter((option) => option.type === "journal")
        ?.map((option) => option.value);

      setSelectedFilterTypes((prevFilters) => ({
        ...prevFilters,
        year: yearValues,
        author: authorValues,
        journal: journalValues,
      }));
    }
  };

  const handleApplyFilter = () => {
    setIsLoaderApply(true);

    const newFilteredArticles = articles.filter((article) => {
      const matchYear = selectedFilterTypes.year.length
        ? selectedFilterTypes.year.includes(article.year)
        : true;

      const matchAuthor = selectedFilterTypes.author.length
        ? selectedFilterTypes.author.some((selectedAuthor) =>
            article.authors
              .split(",")
              ?.map((a) => a.trim())
              .includes(selectedAuthor)
          )
        : true;

      const matchJournal = selectedFilterTypes.journal.length
        ? selectedFilterTypes.journal.includes(article.journal)
        : true;

      const matchTitle = searchText.length
        ? article.title.includes(searchText)
        : true;

      return matchYear && matchAuthor && matchJournal && matchTitle;
    });

    setFilteredArticles(newFilteredArticles);
    setBeforSortingFilterArticles(newFilteredArticles);
    setShowFilterModal(false);
    setIsFilterApplied(true);
    setIsLoaderApply(false);
  };

  const handleResetFilter = () => {
    setSelectedFilterOptions([]);
    setSelectedFilterTypes({
      year: [],
      author: [],
      journal: [],
    });
    setFilterType("");
    setFilterOptions([]);
    setFilteredArticles([]);
    setSearchText("");
    setIsFilterApplied(false);
  };

  // sorting functions
  const sortArticles = (field) => {
    const source = filteredArticles.length
      ? [...filteredArticles]
      : [...articles];
    const sorted = source.sort((a, b) => {
      if (field === "year") {
        return (b[field] || 0) - (a[field] || 0);
      } else if (field === "selected") {
        const isSelectedA = selectedIds.includes(a.id) ? 1 : 0;
        const isSelectedB = selectedIds.includes(b.id) ? 1 : 0;
        return isSelectedB - isSelectedA;
      } else {
        const valueA = a[field] ? a[field].toString().toLowerCase() : "";
        const valueB = b[field] ? b[field].toString().toLowerCase() : "";
        return valueA.localeCompare(valueB);
      }
    });

    if (filteredArticles.length) {
      setFilteredArticles(sorted);
    } else {
      setArticles(sorted);
      setShowSortingDropdown(false);
    }
    setIsSortingApplied(true);
  };

  const handleResetSorting = () => {
    if (filteredArticles.length) {
      setFilteredArticles(beforSortingFilterArticles);
    } else {
      setArticles(beforSortingArticles);
    }
    setIsSortingApplied(false);
  };

  const handleClickOutside = (event) => {
    if (
      sortingDropDownRef.current &&
      !sortingDropDownRef.current.contains(event.target)
    ) {
      setShowSortingDropdown(false);
    }
  };

  const highlightTitle = (text, searchText) => {
    const textToProcess = typeof text === "string" ? text : String(text);

    if (!searchText) return textToProcess;

    const parts = textToProcess.split(new RegExp(`(${searchText})`, "gi"));
    return parts?.map((part, index) =>
      part.toLowerCase() == searchText.toLowerCase() ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  // Toggles abstract based on the index
  const toggleAbstract = (index) => {
    setActiveAbstract(activeAbstract === index ? null : index);
  };

  // Helper function to get the abstract for an article id
  const getAbstractById = (id) => {
    const abstractEntry = articlesAbstracts.find(
      (abstract) => abstract.id === id
    );
    if (!abstractEntry) return "";

    const abstractText = abstractEntry.abstract
      .replace(
        /<ovid:b>(.*?)<\/ovid:b>/g,
        (_, boldText) => `<br><b>${boldText}</b>`
      ) // Bold
      .replace(
        /<ovid:i>(.*?)<\/ovid:i>/g,
        (_, italicText) => `<i>${italicText}</i>`
      ) // Italic
      .replace(
        /<ovid:sub>(.*?)<\/ovid:sub>/g,
        (_, subText) => `<sub>${subText}</sub>`
      ) // Subscript
      .replace(/<ovid:br\/>\s*<ovid:br\/>/g, "<br><br>");
    return parse(abstractText);
  };

  // console.log("selectedFilterTypes", selectedFilterTypes)

  useEffect(() => {
    parseArticles();
    parseInfo();
    getPermissions();
  }, []);
  return (
    <>
      <div className="page--content" onClick={handleClickOutside}>
        <div className="page--section">
          <div className="d-flex justify-content-between align-items-center bg-secondary-template p-1">
            <div className="d-flex querry-font-responsive">
              <p>
                <span className="ms-1">
                  <strong>Database:</strong>
                </span>
                <span className="text-muted ms-1">{picoData.Database}</span>
                <span className="text-muted ms-1">|</span>
              </p>
              <p>
                <span className="ms-1">
                  <strong>Query:</strong>
                </span>
                <span className="text-muted ms-1">{query}</span>
              </p>
            </div>
            {query && (
              <>
                {copyText !== "Copied!" ? (
                  <div className="copy-icon-bg ">
                    <span
                      className="copy-icon ms-2 me-2 text-nowrap"
                      onClick={() => handleCopyText(query)}
                      style={{ cursor: "pointer" }}
                    >
                      <MdContentCopy size={18} /> {copyText}
                    </span>
                  </div>
                ) : (
                  <div className="copied-text-bg">
                    <span className="copy-icon ms-2 me-2 text-nowrap">
                      <MdCheck size={18} /> {copyText}
                    </span>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="row align-items-center">
            <div className="col">
              <h1 className="page--heading">Search Results New</h1>
            </div>

            <div className="col text-end">
              <button
                className="btn back-button add-in-review me-0"
                onClick={() => {
                  handleNavigateBack();
                }}
              >
                Back
              </button>

              {permissions.includes(1) && (
                <button
                  className={
                    isIncludingReview && isSubmitingArticles
                      ? "btn back-button  add-in-review pt-0 pb-0  "
                      : "btn back-button add-in-review"
                  }
                  onClick={() => handleIncludeArticles()}
                  disabled={selectedIds?.length === 0 || isSubmitingArticles}
                >
                  {isIncludingReview && isSubmitingArticles ? (
                    <>
                      <LoaderSmall /> Including in review...
                    </>
                  ) : (
                    "Include in Review"
                  )}
                </button>
              )}
            </div>
          </div>
          <div className="row mt-3 d-flex align-items-center">
            <div className="col">
              {permissions.includes(1) && (
                <div
                  className={
                    "form-check d-flex content-align-center align-items-center"
                  }
                  style={{ marginLeft: "28px" }}
                >
                  {isSelectAllLoader && <Loader />}
                  {!isSelectAllLoader && (
                    <div className="position-relative select-all-wrapper">
                      <input
                        type="checkbox"
                        className="form-check-input me-2 mt-0"
                        name="allSelect"
                        checked={
                          filteredArticles?.length
                            ? filteredArticles.every((article) =>
                                selectedIds.includes(article.id)
                              )
                            : articles?.length === selectedIds?.length
                        }
                        onChange={() => {
                          setIsSelectAllLoader(true);
                          handleSelectAll();
                          setTimeout(() => setIsSelectAllLoader(false), 300);
                        }}
                      />
                    </div>
                  )}

                  <label className="form-check-label " style={{ width: "25%" }}>
                    {filteredArticles?.length
                      ? filteredArticles.every((article) =>
                          selectedIds.includes(article.id)
                        )
                        ? "Deselect All Filtered"
                        : "Select All Filtered"
                      : articles?.length === selectedIds?.length
                      ? "Deselect All"
                      : "Select All"}
                  </label>

                  <div
                    style={{
                      position: "relative",
                      display: "inline-flex",
                      alignItems: "center",
                      marginLeft: "8px",
                    }}
                  >
                    {isSortingApplied ? (
                      <div className="  applied-filter-btn me-2">
                        <div
                          className="d-flex content-align-center align-items-center applied-filter-svg"
                          onClick={() =>
                            setShowSortingDropdown((prev) => !prev)
                          }
                        >
                          <BsSortAlphaDown size={18} className="fw-bold" />{" "}
                          Sorted
                        </div>
                        <div
                          onClick={() => {
                            handleResetSorting();
                          }}
                          className="ms-2 d-flex content-align-center align-items-center applied-cross-btn fw-bold"
                        >
                          <MdCancel size={18} />
                        </div>
                      </div>
                    ) : (
                      <button
                        onClick={() => setShowSortingDropdown((prev) => !prev)}
                        className="d-flex content-align-center align-items-center sort-filter-btn"
                      >
                        <BsSortAlphaDown size={18} /> Sort
                      </button>
                    )}

                    {showSortingDropdown && (
                      <div
                        ref={sortingDropDownRef}
                        style={{
                          position: "absolute",
                          top: "30px",
                          left: 0,
                          backgroundColor: "#ffff",
                          boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
                          zIndex: 1,
                          padding: "8px",
                        }}
                      >
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("year")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Year
                        </div>
                        {selectedIds?.length < articles?.length &&
                          selectedIds?.length !== 0 && (
                            <div
                              className="sort-list-dropdown"
                              onClick={() => sortArticles("selected")}
                              style={{ cursor: "pointer", padding: "4px 8px" }}
                            >
                              Selected
                            </div>
                          )}

                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("title")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Title
                        </div>
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("journal")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Journal
                        </div>
                        <div
                          className="sort-list-dropdown"
                          onClick={() => sortArticles("authors")}
                          style={{ cursor: "pointer", padding: "4px 8px" }}
                        >
                          Authors
                        </div>
                      </div>
                    )}

                    {isFilterApplied ? (
                      <div className="  applied-filter-btn">
                        <div
                          className="d-flex content-align-center align-items-center applied-filter-svg"
                          onClick={() => setShowFilterModal(true)}
                        >
                          <FiFilter size={18} /> Filtered
                        </div>
                        <div
                          onClick={() => {
                            handleResetFilter();
                          }}
                          className="ms-2 d-flex content-align-center align-items-center applied-cross-btn fw-bold"
                        >
                          <MdCancel size={18} />
                        </div>
                      </div>
                    ) : (
                      <button
                        onClick={() => setShowFilterModal(true)}
                        className="sort-filter-btn d-flex content-align-center align-items-center"
                      >
                        <FiFilter size={18} /> Filter
                      </button>
                    )}
                    {filteredArticles?.length > 0 && (
                      <label className="ms-3 count-colour">
                        Filtered: <strong>{filteredArticles?.length}</strong>
                      </label>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className="col text-end me-3 count-colour">
              <label>
                Total: <strong>{articles?.length}</strong>
              </label>
              <label className="ms-3">
                Selected: <strong>{selectedIds?.length}</strong>
              </label>
            </div>
          </div>
        </div>
        <div>
          {listingLoader ? (
            <div className="listing-loader d-flex">
              <Loader2 />
            </div>
          ) : (
            (isFilterApplied ? filteredArticles : articles)?.map(
              (article, index) => (
                <div className="form-check col-lg-12" key={article?.id}>
                  {permissions.includes(1) && (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      onChange={() => handleSelectChange(article?.id)}
                      checked={selectedIds.includes(article?.id)}
                    />
                  )}
                  <div className="inner--box--row">
                    <span className="index--numbering fw-bold">
                      {index + 1})
                    </span>

                    <div>
                      <h1 className="heading3">
                        {searchText?.length && filteredArticles?.length
                          ? highlightTitle(
                              formatOvidTags(article?.title),
                              searchText
                            )
                          : formatOvidTags(article?.title)}
                      </h1>
                      <p className="small text-muted authors-font">
                        <span className="authors-font fw-bold">
                          Author(s):{" "}
                        </span>
                        {/* {article.authors} */}
                        {article?.authors?.split(",")?.map((author, i) => {
                          const trimmedAuthor = author.trim();
                          const isHighlighted =
                            selectedFilterTypes?.author?.includes(
                              trimmedAuthor
                            );
                          return (
                            <span
                              key={i}
                              style={
                                isHighlighted && filteredArticles?.length
                                  ? {
                                      backgroundColor: "yellow",
                                      fontWeight: "bold",
                                      padding: "2px 4px",
                                      borderRadius: "4px",
                                    }
                                  : {}
                              }
                            >
                              {trimmedAuthor}
                              {i < article.authors.split(",").length - 1
                                ? ", "
                                : "."}
                            </span>
                          );
                        })}
                      </p>
                      <p
                        className="small text-muted journal-font"
                        htmlFor="flexCheckDefault2"
                      >
                        <span className="fw-bold">Journal:</span>{" "}
                        <span
                          style={
                            filteredArticles?.length &&
                            selectedFilterTypes?.journal?.includes(
                              article?.journal
                            )
                              ? {
                                  backgroundColor: "yellow",
                                  fontWeight: "bold",
                                  padding: "2px 4px",
                                  borderRadius: "4px",
                                }
                              : {}
                          }
                        >
                          {" "}
                          {article?.journal + "."}
                        </span>
                      </p>

                      <div>
                        <p className="small text-muted journal-font">
                          <span className="fw-bold">Year:</span>{" "}
                          <span
                            style={
                              filteredArticles?.length &&
                              selectedFilterTypes?.year?.includes(article?.year)
                                ? {
                                    backgroundColor: "yellow",
                                    fontWeight: "bold",
                                    padding: "2px 4px",
                                    borderRadius: "4px",
                                  }
                                : {}
                            }
                          >
                            {article?.year}{" "}
                          </span>
                        </p>
                      </div>
                      <p
                        className={
                          activeAbstract === index
                            ? "Increase-height--of--paragraph cursor-pointer"
                            : "Increase-height--of--paragraph underline-showAbstarct"
                        }
                        onClick={() => toggleAbstract(index)}
                      >
                        {activeAbstract === index
                          ? getAbstractById(article.id) ||
                            "No Abstract Available"
                          : "Show Abstract"}
                      </p>
                    </div>
                  </div>
                </div>
              )
            )
          )}

          {isFilterApplied && filteredArticles?.length === 0 && (
            <div className="no-data-found-main">
              <h5 className="no-data-found text-muted m-auto opacity-50">
                <FaExclamationTriangle size={50} color="orange" />
                <span className="ms-3">No match records found.</span>
              </h5>
            </div>
          )}
        </div>
      </div>
      <ConfirmAddArticlesModal
        showModal={showRemoveArticlesModal}
        setShowModal={setShowRemoveArticlesModal}
        countEmptyArticles={emptyTitleOrAbstractCount}
        handleContinue={handleSubmitArticles}
        payloadArticles={payloadArticles}
        setIsSubmitingArticles={setIsSubmitingArticles}
      />
      <FilterModal
        showFilterModal={showFilterModal}
        setShowFilterModal={setShowFilterModal}
        filterType={filterType}
        setFilterType={setFilterType}
        filterOptions={filterOptions}
        selectedFilterOptions={selectedFilterOptions}
        handleFilterChange={handleFilterChange}
        handleSelectFilterChange={handleSelectFilterChange}
        handleApplyFilter={handleApplyFilter}
        handleResetFilter={handleResetFilter}
        searchText={searchText}
        setSearchText={setSearchText}
        isLoaderApply={isLoaderApply}
      />
    </>
  );
};

export default ListingSelectionsComponentNew;
